onComplete(function () {
	// document.querySelectorAll(".content-subtemplate-home .main .row")
	// 	.forEach(el => {
	// 		el.classList.add("clamp-left-unclamp-right");
	// 		el.classList.remove("row");
	// 	});

	// document.querySelectorAll(".content-subtemplate-home .main *")
	// 	.forEach(el => {
	// 		const classesToRemove = Array.from(el.classList).filter(cls =>
	// 			/^(col|offset)/.test(cls)
	// 		);
	// 		if (classesToRemove.length) {
	// 			el.classList.remove(...classesToRemove);
	// 		}
	// 	});

	const el = document.querySelector(".content-subtemplate-home .blog-overview");
	if (el) {
		el.classList.add("blog-template-basic");
	}

	const el2 = document.querySelector(".content-subtemplate-content .blog-overview");
	if (el2) {
		el2.classList.add("blog-template-basic");
	}
});